import { appStyles } from '../../App.styles';
export const avatarSGStyles = {
    menuItem: Object.assign(Object.assign({}, appStyles.text16), { width: '100%', color: 'blackDark.main', textAlign: 'left', alignItems: 'left' }),
};
